import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import * as Sentry from '@sentry/browser';
import * as actions from '../../constants';
import { removeCookie } from '../../helpers';

var logOutRequest = function logOutRequest() {
  return {
    type: actions.LOG_OUT_REQUEST
  };
};

var logOutSuccess = function logOutSuccess() {
  return {
    type: actions.LOG_OUT_SUCCESS
  };
};

var logOutFailure = function logOutFailure(error) {
  return {
    type: actions.LOG_OUT_FAILURE,
    error: error
  };
};

export var logOut = function logOut(callback) {
  return function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // TODO: Call logout API once it has been created. For now, just clearing state.
              dispatch(logOutRequest());
              removeCookie();
              _context.prev = 2;
              _context.next = 5;
              return dispatch(logOutSuccess());

            case 5:
              if (!callback) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return dispatch(callback());

            case 8:
              return _context.abrupt('return', true);

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](2);
              dispatch(logOutFailure(_context.t0));
              Sentry.captureException(_context.t0);
              console.error(_context.t0);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};